export const loadingLabel = {
  en: 'Loading',
  sv: 'Laddar',
};
